import React, { useEffect, useLayoutEffect } from 'react';

//third party libs
import { Routes, Route, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

//Layouts
import EmptyLayout from '../Layouts/EmptyLayout';
import MainLayout from '../Layouts/MainLayout';

// containers and components
import InvestmentOpportunities from '../InvestmentOpportunities';
import ErrorFallback from '../../components/ErrorFallback';
import { PAGE_TITLES } from '../../helpers/constants';
import AccreditationForm from '../AccreditationForm';
import InvestESign from '../Invest/InvestESign';
import ResetPassword from '../ResetPassword';
import Accreditation from '../Accreditation';
import ThankYouPage from '../ThankYouPage';
import StartupPage from '../StartupPage';
import AffirmationDenied from '../Affirmation/AffirmationDenied';
import FounderPage from '../FounderPage';
import FounderSubmitted from '../FounderPage/FounderSubmitted';
import UploaderSubmitted from '../DocumentsUploader/UploaderSubmitted';
import Impersonate from '../Impersonate';
import EmailVerification from '../EmailVerification';
import Dashboard from '../Dashboard';
import MyProfile from '../MyProfile';
import KycStatus from '../KycStatus';
import Documents from '../Documents';
import LoginPage from '../LoginPage';
import Startups from '../Startups';
import Invest from '../Invest';
import Nda from '../Nda';
import NdaThank from '../Nda/Thank';
import Kyc from '../Kyc';
import DocumentsUploader from '../DocumentsUploader';
import Sync from '../Sync';

// New Pages
import Homepage from '../../pages/Homepage';
import Investors from '../../pages/Investors';
import Entrepreneurs from '../../pages/Entrepreneurs';
import About from '../../pages/About';
import FAQ from '../../pages/FAQ';
import HowItWorks from '../../pages/HowItWorks';
import Glossary from '../../pages/Glossary';
import Testimonials from '../../pages/Testimonials';
import Portfolio from '../../pages/Portfolio';
import DealRoom from '../../pages/DealRoom';
import QAForum from '../../pages/QAForum';
import PortfolioDashboard from '../../pages/PortfolioDashboard';
import AdminDashboard from '../../pages/AdminDashboard';
import KYCFlow from '../../pages/KYCFlow';
import InvestmentFlow from '../../pages/InvestmentFlow';
import Notifications from '../../pages/Notifications';
import Reports from '../../pages/Reports';
import StartupUpdates from '../../pages/StartupUpdates';
import AboutUs from '../../pages/AboutUs';
import Capital from '../../pages/Capital';
import PrivacyPolicy from '../../pages/PrivacyPolicy';
import Jobs from '../../pages/Jobs';

import HubSpotChat from "../../components/HubSpotChat/HubSpotChat";

import { refreshTraitsAttempt } from './actions';

import { track, init, time } from '../../services/analytics';
import OpenRolloverPopup from '../RolloverPopup/OpenRolloverPopup';
import { loadConfig } from '../..//env/config_util';

const App = (props) => {
  // hooks
  const location = useLocation();
  const pathname = location.pathname;
  const config = loadConfig();
  
  const dispatch = useDispatch();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });

  useEffect(() => {
    if (document.readyState === 'complete') {
      track('Page Change', { url: pathname });
      time('Page Change');
      dispatch(refreshTraitsAttempt({}));
    }
  }, [pathname, dispatch]);

  useEffect(() => {
    if (document.readyState === 'complete') init();
  });

  return (
    <>
    <Routes>
      <Route
        exact
        path="/"
        element={
          <MainLayout title={PAGE_TITLES.dashboard} lockGuard={true} navigateTo="dashboard" hasNext={true} track="home">
            <LoginPage />
          </MainLayout>
        }
      />
      <Route
        exact
        path="/sso/signin"
        element={
          <MainLayout title={PAGE_TITLES.dashboard} lockGuard={true} navigateTo="dashboard" hasNext={true} track="home">
            <LoginPage />
          </MainLayout>
        }
      />
      <Route
        exact
        path="/sso/signup"
        element={
          <MainLayout title={PAGE_TITLES.dashboard} lockGuard={true} navigateTo="dashboard" hasNext={true} track="home" isSignup={true}>
            <LoginPage />
          </MainLayout>
        }
      />
      <Route
        path="/login"
        element={
          <EmptyLayout title={PAGE_TITLES.Login} lockGuard={true} navigateTo="dashboard" hasNext={true} track="signin">
            <LoginPage />
          </EmptyLayout>
        }
      />
      <Route
        path="/dashboard"
        element={
          <MainLayout
            title={PAGE_TITLES.dashboard}
            lockGuard={true}
            navigateTo="dashboard"
            hasNext={false}
            track="dashboard"
          >
            <Dashboard />
          </MainLayout>
        }
      />
      <Route
        path="/investment-opportunities"
        element={
          <MainLayout
            title={PAGE_TITLES.investmentOpportunities}
            lockGuard={true}
            navigateTo="investment-opportunities"
            hasNext={false}
            track="investment-opportunities"
          >
            <InvestmentOpportunities />
          </MainLayout>
        }
      />
      <Route
        path="/profile"
        element={
          <MainLayout title={PAGE_TITLES.profile} lockGuard={true} navigateTo="profile" hasNext={false} track="profile">
            <MyProfile />
          </MainLayout>
        }
      />
      <Route
        path="/change-password"
        element={
          <MainLayout
            title={PAGE_TITLES.changePassword}
            lockGuard={false}
            navigateTo="dashboard"
            hasNext={false}
            track="change-password"
          >
            <ResetPassword />
          </MainLayout>
        }
      />
      <Route
        path="/founder"
        element={
          <MainLayout
            title={PAGE_TITLES.founder}
            lockGuard={false}
            navigateTo="founder"
            hasNext={false}
            track="founder-show"
          >
            <FounderPage />
          </MainLayout>
        }
      />
      <Route
        path="/foundersubmitted"
        element={
          <MainLayout
            title={PAGE_TITLES.founder}
            lockGuard={false}
            navigateTo="foundersubmitted"
            hasNext={false}
            track="founder-thank-you"
          >
            <FounderSubmitted />
          </MainLayout>
        }
      />
      <Route
        path="/startups"
        element={
          <MainLayout
            title={PAGE_TITLES.startups}
            navigateTo="startups"
            lockGuard={false}
            hasNext={false}
            track="funded-opportunities"
          >
            <Startups />
          </MainLayout>
        }
      />
      <Route
        path="/browse/startups"
        element={
          <MainLayout
            title={PAGE_TITLES.startups}
            navigateTo="startups"
            lockGuard={false}
            hasNext={false}
            track="funded-opportunities"
          >
            <Startups />
          </MainLayout>
        }
      />
      <Route
        path="/homepage"
        element={
          <MainLayout
            title="iAngels — Venture Beyond"
            navigateTo="homepage"
            lockGuard={false}
            hasNext={false}
            track="homepage"
          >
            <Homepage />
          </MainLayout>
        }
      />
      <Route
        path="/investors"
        element={
          <MainLayout
            title="Investors — iAngels"
            navigateTo="investors"
            lockGuard={false}
            hasNext={false}
            track="investors"
          >
            <Investors />
          </MainLayout>
        }
      />
      <Route
        path="/entrepreneurs"
        element={
          <MainLayout
            title="Entrepreneurs — iAngels"
            navigateTo="entrepreneurs"
            lockGuard={false}
            hasNext={false}
            track="entrepreneurs"
          >
            <Entrepreneurs />
          </MainLayout>
        }
      />
      <Route
        path="/about"
        element={
          <MainLayout
            title="About Angels67"
            navigateTo="about"
            lockGuard={false}
            hasNext={false}
            track="about"
          >
            <About />
          </MainLayout>
        }
      />
      <Route
        path="/faq"
        element={
          <MainLayout
            title="FAQ - Frequently Asked Questions"
            navigateTo="faq"
            lockGuard={false}
            hasNext={false}
            track="faq"
          >
            <FAQ />
          </MainLayout>
        }
      />
      <Route
        path="/how-it-works"
        element={
          <MainLayout
            title="How It Works"
            navigateTo="how-it-works"
            lockGuard={false}
            hasNext={false}
            track="how-it-works"
          >
            <HowItWorks />
          </MainLayout>
        }
      />
      <Route
        path="/glossary"
        element={
          <MainLayout
            title="Investment Glossary"
            navigateTo="glossary"
            lockGuard={false}
            hasNext={false}
            track="glossary"
          >
            <Glossary />
          </MainLayout>
        }
      />
      <Route
        path="/testimonials"
        element={
          <MainLayout
            title="Investor Testimonials"
            navigateTo="testimonials"
            lockGuard={false}
            hasNext={false}
            track="testimonials"
          >
            <Testimonials />
          </MainLayout>
        }
      />
      <Route
        path="/portfolio"
        element={
          <MainLayout
            title="Our Portfolio"
            navigateTo="portfolio"
            lockGuard={false}
            hasNext={false}
            track="portfolio"
          >
            <Portfolio />
          </MainLayout>
        }
      />
      {/* no need for title here, we use slug */}
      <Route
        path="/startup/:slug"
        element={
          <MainLayout navigateTo="startup" lockGuard={false} hasNext={false} track="startup.memo">
            <StartupPage />
          </MainLayout>
        }
      />
      <Route
        path="/startup/:slug/rollover"
        element={
          <MainLayout navigateTo="startup" lockGuard={false} hasNext={false} track="startup.rollover">
            <StartupPage isRollover={true}/>
          </MainLayout>
        }
      />
      <Route
        path="/startup/:slug/snapshot"
        element={
          <MainLayout navigateTo="startup" lockGuard={false} hasNext={false} track="startup.memo">
            <StartupPage />
          </MainLayout>
        }
      />
      <Route
        path="/child-startup/:slug"
        element={
          <MainLayout navigateTo="child-startup" lockGuard={false} hasNext={false}>
            <StartupPage isChild={true} />
          </MainLayout>
        }
      />
      <Route
        path="/startup/:slug/nda/thank-you"
        element={
          <MainLayout lockGuard={true} navigateTo="dashboard" hasNext={false} track="startup.nda">
            <NdaThank />
          </MainLayout>
        }
      />
      <Route
        path="/startup/:slug/nda"
        element={
          <MainLayout lockGuard={true} navigateTo="dashboard" hasNext={false} track="startup.nda">
            <Nda />
          </MainLayout>
        }
      />
      <Route
        path="/invest/:currentRoundId/entity/:amount"
        element={
          <MainLayout title={PAGE_TITLES.invest} lockGuard={true} navigateTo="dashboard" hasNext={false} track="entity">
            <Invest />
          </MainLayout>
        }
      />
      <Route
        path="/invest/esign/:investmentType/:investmentId/:isRollover"
        element={
          <MainLayout title={PAGE_TITLES.invest} lockGuard={true} navigateTo="dashboard" hasNext={false} track="esign">
            <InvestESign />
          </MainLayout>
        }
      />
      <Route
        path="/invest/:investmentType/:investmentId/kyc"
        element={
          <MainLayout title={PAGE_TITLES.invest}>
            <Kyc />
          </MainLayout>
        }
      />
      <Route
        path="/invest/:investmentType/:investmentId/thank-you"
        element={
          <MainLayout title={PAGE_TITLES.thankYou} lockGuard={true} navigateTo="dashboard" hasNext={false}>
            <ThankYouPage />
          </MainLayout>
        }
      />
      <Route
        path="/entity/upload/:id"
        element={
          <MainLayout lockGuard={true} navigateTo="dashboard" hasNext={false} track="upload-forms">
            <Kyc />
          </MainLayout>
        }
      />
      <Route
        path="/entity/verification"
        element={
          <MainLayout lockGuard={true} navigateTo="entity/verification" hasNext={false} track="account-verification">
            <KycStatus />
          </MainLayout>
        }
      />
      <Route
        path="/documents"
        element={
          <MainLayout
            title={PAGE_TITLES.documents}
            lockGuard={true}
            navigateTo="documents"
            hasNext={false}
            track="documents"
          >
            <Documents />
          </MainLayout>
        }
      />
       <Route
        path="/rolloverPopup"
        element={
            <MainLayout
              title={PAGE_TITLES.dashboard}
              lockGuard={true}
              navigateTo="dashboard"
              hasNext={false}
              track="rolloverPopup"
            >
              <OpenRolloverPopup />
            </MainLayout>
          }
        />
      <Route
        path="/user/not-accredited"
        element={
          <MainLayout navigateTo="dashboard" lockGuard={false} hasNext={false}>
            <AffirmationDenied />
          </MainLayout>
        }
      />
      <Route
        path="/error"
        element={
          <MainLayout title={PAGE_TITLES.error} track="error">
            <ErrorFallback />
          </MainLayout>
        }
      />
      <Route
        path="/accreditation/:countryCode"
        element={
          <EmptyLayout
            whiteBg={true}
            title={PAGE_TITLES.accreditation}
            lockGuard={true}
            navigateTo="dashboard"
            hasNext={false}
          >
            <Accreditation />
          </EmptyLayout>
        }
      />
      <Route
        path="/accreditation"
        element={
          <MainLayout
            title={PAGE_TITLES.accreditation}
            lockGuard={true}
            navigateTo="accreditation"
            hasNext={false}
            track="update-accreditation"
          >
            <AccreditationForm />
          </MainLayout>
        }
      />

      <Route
        path="/uploader"
        element={
          <EmptyLayout
            title={PAGE_TITLES.uploader}
            lockGuard={true}
            hasNext={true}
            navigateTo="uploader"
            whiteBg={true}
          >
            <DocumentsUploader />
          </EmptyLayout>
        }
      />
      <Route
        path="/uploadersubmitted"
        element={
          <EmptyLayout
            title={PAGE_TITLES.uploader}
            lockGuard={false}
            navigateTo="uploadersubmitted"
            hasNext={false}
            whiteBg={true}
          >
            <UploaderSubmitted />
          </EmptyLayout>
        }
      />
      <Route
        path="/sync"
        element={
          <EmptyLayout
            title={PAGE_TITLES.sync}
            lockGuard={true}
            hasNext={true}
            navigateTo="sync"
            whiteBg={true}
          >
            <Sync />
          </EmptyLayout>
        }
      />

      <Route
        path="/imper"
        element={
          <MainLayout lockGuard={false} navigateTo="dashboard" hasNext={false}>
            <Impersonate />
          </MainLayout>
        }
      />
      <Route
        path="/email-verification"
        element={
          <MainLayout lockGuard={false} navigateTo="dashboard" hasNext={false}>
            <EmailVerification />
          </MainLayout>
        }
      />
      {/* New Angels67 v2 Pages */}
      <Route
        path="/dealroom/:startupId"
        element={
          <MainLayout title="Deal Room" lockGuard={true} navigateTo="dashboard" hasNext={false} track="dealroom">
            <DealRoom />
          </MainLayout>
        }
      />
      <Route
        path="/qa/:startupId"
        element={
          <MainLayout title="Q&A Forum" lockGuard={true} navigateTo="dashboard" hasNext={false} track="qa-forum">
            <QAForum />
          </MainLayout>
        }
      />
      <Route
        path="/my-portfolio"
        element={
          <MainLayout title="My Portfolio" lockGuard={true} navigateTo="my-portfolio" hasNext={false} track="portfolio-dashboard">
            <PortfolioDashboard />
          </MainLayout>
        }
      />
      <Route
        path="/admin"
        element={
          <MainLayout title="Admin Dashboard" lockGuard={true} navigateTo="admin" hasNext={false} track="admin-dashboard">
            <AdminDashboard />
          </MainLayout>
        }
      />
      <Route
        path="/kyc"
        element={
          <MainLayout title="KYC Verification" lockGuard={true} navigateTo="kyc" hasNext={false} track="kyc-flow">
            <KYCFlow />
          </MainLayout>
        }
      />
      <Route
        path="/invest-flow/:startupId"
        element={
          <MainLayout title="Invest" lockGuard={true} navigateTo="dashboard" hasNext={false} track="investment-flow">
            <InvestmentFlow />
          </MainLayout>
        }
      />
      <Route
        path="/notifications"
        element={
          <MainLayout title="Notifications" lockGuard={true} navigateTo="notifications" hasNext={false} track="notifications">
            <Notifications />
          </MainLayout>
        }
      />
      <Route
        path="/reports"
        element={
          <MainLayout title="Reports" lockGuard={true} navigateTo="reports" hasNext={false} track="reports">
            <Reports />
          </MainLayout>
        }
      />
      <Route
        path="/updates/:startupId"
        element={
          <MainLayout title="Startup Updates" lockGuard={true} navigateTo="dashboard" hasNext={false} track="startup-updates">
            <StartupUpdates />
          </MainLayout>
        }
      />

      <Route
        path="/about-us"
        element={
          <MainLayout title="About Us - iAngels" navigateTo="about-us" lockGuard={false} hasNext={false} track="about-us">
            <AboutUs />
          </MainLayout>
        }
      />
      <Route
        path="/capital"
        element={
          <MainLayout title="Capital - iAngels" navigateTo="capital" lockGuard={false} hasNext={false} track="capital">
            <Capital />
          </MainLayout>
        }
      />
      <Route
        path="/privacy-policy"
        element={
          <MainLayout title="Privacy Policy - iAngels" navigateTo="privacy-policy" lockGuard={false} hasNext={false} track="privacy-policy">
            <PrivacyPolicy />
          </MainLayout>
        }
      />
      <Route
        path="/jobs"
        element={
          <MainLayout title="Jobs - iAngels" navigateTo="jobs" lockGuard={false} hasNext={false} track="jobs">
            <Jobs />
          </MainLayout>
        }
      />

      <Route
        path="*"
        element={
          <MainLayout track="error">
            <ErrorFallback />
          </MainLayout>
        }
      />
    </Routes>
     {/*  Controller: lazy script + SPA refresh + global open() */}
    <HubSpotChat portalId={config.config_module.hubspot_portal_id} hublet={config.config_module.hubspot_hublet} />
   </>
  );
};

export default App;
